import React from "react";

import AppIcon from "src/commun/composants/AppIcon";
import { AppNestedMenu, MenuItemData } from "fer-react-components";
import { useAppState } from "src/app/state/StateProvider";
import styles from "src/app/menu/wallet/Wallet.scss";
import { goToUrl } from "src/app/menu/menuutil";
import { useNavigate } from "react-router-dom";
import { useAppText } from "src/commun/composants/AppText";

const Wallet = () => {

  const [{ menu, langue }] = useAppState();

  const navigate = useNavigate();

  const { tString } = useAppText();

  const menuItemsData: MenuItemData | undefined =
    {
      leftIcon: <AppIcon title={tString("menu.wallet.title")} className={"cursor-pointer couleurIconBleu"} name="menu-gestion" size="26px"/>,
      items:
          (menu?.wallet ?? []).map(
          (point) => {
            return {
              label: point.labels[langue],
              callback: () => goToUrl(point.url, point.openInNewTab, navigate),
              leftIcon: <>
                <AppIcon name={point.code} size="26px"/>
                {point.withNotification && <span className={`${styles.notifs} ${point.counter && styles.notifsWithCounter}`}>{point.counter ? point.counter : <>&nbsp;</>}</span>}
              </>,
              items: point.menuItems.map((sousPoint) => {
                  return {
                    label: sousPoint.labels[langue],
                    callback: () => goToUrl(sousPoint.url, sousPoint.openInNewTab, navigate),
                    leftIcon: <>
                      <AppIcon name={point.code} size="26px"/>
                      {sousPoint.withNotification && <span className={`${styles.notifs} ${sousPoint .counter && styles.notifsWithCounter}`}>{sousPoint.counter ? sousPoint.counter : <>&nbsp;</>}</span>}
                    </>,
                  };
                },
              ),
            };
          },
        ),


    };


  return <AppNestedMenu menuItemsData={menuItemsData}/>;
};

export default Wallet;
